module.exports = __webpack_public_path__ + "img/waves-white.9fe94fe4.svg";